<template>
  <!-- 自定义插槽
	多选上传-->

  <el-upload
    ref="linkUpload"
    :data="qnData"
    :action="action"
    :on-error="handleError"
    :on-success="handleSucces"
    :on-remove="batchRemoveFile"
    :on-exceed="batchImportExceed"
    :on-progress="handleProgress"
    :before-upload="handleBefore"
    :limit="limit"
    :file-list="fileList"
    :show-file-list="showFileList"
    :multiple="multiple"
    :accept="accept"
    :http-request="handleUploadAdd"
  >
    <div slot="file" slot-scope="{ file }">
      <i
        v-if="file.status == 'success' && showFileList"
        class="item-document el-icon-document"
      ></i>
      <i v-if="file.status == 'success' && showFileList">
        {{
          (file.attachName || file.attachUrl) + '---' + file.attachSize + 'kb'
        }}</i
      >
      <i
        v-if="file.status == 'success' && showFileList"
        @click="batchRemoveFile(file)"
        class="item-delete-link el-icon-delete"
      ></i>
      <el-progress
        v-if="file.status != 'success'"
        class="up-progress"
        size="mini"
        :percentage="percent"
      ></el-progress>
    </div>
    <slot name="body"></slot>
  </el-upload>
</template>

<script>
import { conf } from '@/config'
import { getData } from '@/http/fetch.js'
import Compressor from 'compressorjs'
import * as QiNiu from 'qiniu-js'
export default {
  props: {
    // image/*
    accept: {
      type: String,
      default: '*'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 15
    },
    // {
    // 		attachSize: 123,
    // 		attachType: "jpg",
    // 		attachUrl: "http://192.168.1.218/nwdfile/202108/gw6qIH.jpeg",
    // 		name:"gw6qIH.jpeg",
    // 	}
    fileList: {
      type: Array
    },
    showFileList: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    action() {
      return conf.uploadAction
    }
  },
  data() {
    return {
      percent: 0,
      // fileList: [
      // 	{
      // 		attachSize: 123,
      // 		attachType: "jpg",
      // 		attachUrl: "http://192.168.1.218/nwdfile/202108/gw6qIH.jpeg",
      // 		name: "gw6qIH.jpeg"
      // 	}
      // ]
      fileSize: 2000,
      qnData: {
        token: '',
        key: ''
      },
      domainUrl: ''
    }
  },

  methods: {
    getToken(file) {
      return getData('/file/getQiNiuAccessToken')
        .then((res) => {
          this.domainUrl = res.domainUrl
          this.qnData.token = res.accessToken
          this.qnData.key =
            new Date().getTime() +
            '.' +
            file.name.split('.')[file.name.split('.').length - 1] // 处理上传同名文件失败加上时间戳
        })
        .catch((err) => {
          this.$message({ type: 'error', message: err })
        })
    },
    presser(file) {
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          maxWidth: 2000,
          maxHeight: 2000,
          quality: 0.8,
          success: (result) => {
            return resolve(result)
          },
          error: (err) => {
            reject(err)
            this.$message({ type: 'error', message: err })
          }
        })
      })
    },
    async handleBefore(file, fileList) {
      console.log('handleBefore', file, fileList)
      //文件大小判断
      if (file.size / 1024 / 1024 > this.fileSize) {
        this.$message.error('上传文件大小必须小于' + this.fileSize + 'MB')
        return false
      }
      await this.getToken(file)
      this.$emit('uploadloading', true)
      if (file.type.includes('image')) {
        return this.presser(file)
      } else {
        return true
      }
    },
    clearFiles() {
      this.$refs.linkUpload.clearFiles()
    },

    //上传成功
    async handleSucces(response, file, fileList) {
      console.log('handleSucces', fileList)
      // fileList 新增上传的存在response.data
      // 回显的 不存在
      if (fileList.every((item) => item.status === 'success')) {
        let temFileList = []
        fileList.forEach((item) => {
          // attachName: "人物动漫.jpeg"
          // attachSize: 26
          // attachType: "jpeg"
          // attachUrl: "http://101.89.139.158:88/nwdfile/202109/urfO9y.jpeg"
          // id: 1631696700259
          if (item.response) {
            let data = {
              attachName: item.name,
              attachSize: parseFloat(item.size / 1024).toFixed(0),
              attachType: item.name.replace(/.+\./, '').toLowerCase(),
              attachUrl: this.domainUrl + item.response.key,
              id: item.uid
            }
            //新增上传的
            temFileList.push(data)
          } else {
            //回显的
            temFileList.push(item)
          }
        })
        this.$emit('uploadloading', false)
        this.$emit('changeUpload', temFileList)
      }
    },
    //失败
    handleError() {
      this.$emit('uploadloading', false)
      this.$message.warning('上传失败请稍后重试！')
    },
    //文件列表移除文件时的钩子
    batchRemoveFile(file) {
      let index = this.fileList.findIndex((f) => {
        return f.attachName == file.attachName
      })
      if (index != -1) {
        this.fileList.splice(index, 1)
      }
      this.$emit('changeUpload', this.fileList)
    },
    // 批量导入-定义超出限制时的行为
    batchImportExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择` +
          this.limit +
          `个文件，本次选择了 ${files.length} 个文件，共选择了 ${
            files.length + fileList.length
          } 个文件`
      )
    },
    handleProgress(event, file, fileList) {
      this.percent = parseInt(event.percent + 0)
      //console.log("--------event, file, fileList",event.percent);
    },
    handleUploadAdd({ file, onSuccess, onError, onProgress }) {
      const putExtra = {
        fname: file.name
      }
      const observableOptions = {
        next: (res) => {
          onProgress({ percent: res.total.percent }, file)
        },
        error: (err) => {
          onError(err)
        },
        complete: (res) => {
          onSuccess(res)
        }
      }
      const config = {
        useCdnDomain: true,
        concurrentRequestLimit: 3,
        chunkSize: 10
      }
      QiNiu.upload(
        file,
        this.qnData.key,
        this.qnData.token,
        putExtra,
        config
      ).subscribe(observableOptions)
    }
  }
}
</script>

<style lang="less" scoped>
.item-delete-link {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 20px;
}
.item-delete-link:hover {
  color: red;
}
::v-deep.up-progress {
  .el-progress-bar__outer {
    height: 3px !important;
  }
}
</style>
